import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "../slices/homeSlice";
import blogReducer from "../slices/blogSlice";
import activityReducer from "../slices/activitySlice";
import attractionsReducer from "../slices/attractionsSlice";
import diningReducer from "../slices/diningSlice";
import eventReducer from "../slices/eventSlice";
import roomReducer from "../slices/roomSlice";
import offerReducer from "../slices/offerSlice";
import landingPageReducer from "../slices/landingPageSlice";

const store = configureStore({
  reducer: {
    home: homeReducer,
    blog: blogReducer,
    activity: activityReducer,
    attractions: attractionsReducer,
    dining: diningReducer,
    event: eventReducer,
    room: roomReducer,
    offer: offerReducer,
    landingPage: landingPageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
